import axios from 'axios';

import { LoadingService } from '../AppLoading';

import { baseURL } from '../config';

import { ToastService } from '../AppToast';
import { translateError } from '../shared/language';

import { AppStorage } from './UserStorage';
import { addLocalizationHeader } from './requestHeaders';

const _axios = axios.create({
  baseURL,
  xsrfHeaderName: 'RequestVerificationToken',
});

const shouldSkipLoading = (config: { url?: string; skipLoading?: boolean }) => {
  if (config.skipLoading) {
    return true;
  }

  const url = config.url || '';
  return (
    url.includes('print-payment-log') ||
    url.includes('payment-status') ||
    url.includes('status-payment')
  );
};

const normalizeBlobError = async (error: any) => {
  const response = error?.response;
  const data = response?.data;

  if (
    response?.config?.responseType !== 'blob' ||
    typeof Blob === 'undefined' ||
    !(data instanceof Blob) ||
    typeof data.text !== 'function'
  ) {
    return;
  }

  try {
    const text = await data.text();
    if (text) {
      response.data = JSON.parse(text);
    }
  } catch {
    // Giữ nguyên Blob nếu response không phải JSON.
  }
};

_axios.interceptors.request.use(function (config) {
  addLocalizationHeader(config);
  if (!shouldSkipLoading(config)) {
    LoadingService.start();
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
_axios.interceptors.response.use(async (response) => {
  if (!shouldSkipLoading(response.config)) {
    LoadingService.stop();
  }

  if (response?.status === 302) {
    const originalRequest: any = response.config;
    if (originalRequest._retried) {
      window.location.hash = '/login';
    } else {
      try {
        await _axios.post(`account/login`, { userNameOrEmailAddress: AppStorage.get('UserName'), password: AppStorage.get('Pass'), rememberMe: false });

        originalRequest._retried = true;
        return _axios(originalRequest);
      } catch (e) {
        window.location.hash = '/login';
      }
    }
  }
  return response;
}, async (error) => {
  if (!shouldSkipLoading(error.config || {})) {
    LoadingService.stop();
  }
  if (error?.response?.status === 0 || error?.response?.status === 302 || error?.response?.status === 401) {
    const originalRequest = error.config;
    if (originalRequest._retried) {
      window.location.hash = '/login';
    } else {
      try {
        await _axios.post(`account/login`, { userNameOrEmailAddress: AppStorage.get('UserName'), password: AppStorage.get('Pass'), rememberMe: false });

        originalRequest._retried = true;
        return _axios(originalRequest);
      } catch (e) {
        window.location.hash = '/login';
      }
    }
  }
  let show = true;
  if (error && error.config && error.config.url === 'account/logout') {
    show = false;
  }
  await normalizeBlobError(error);
  if (show) {
    showError(error);
  }

  return Promise.reject(error);
});


const showError = ({ response }) => {
  if (response) {
    ToastService.error(translateError(response));
  }
}

export default _axios;
